import { IconMessages, IconPhoneCall } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';

/**
 * Регистрация навигационных карточек magsnab на WelcomePage.
 *
 * Карточки живут в инстансе, а не в модуле avito: что выносить на главную —
 * политика конкретного клиента, а не свойство интеграции.
 */
export function registerMagsnabWelcomeExtensions(): void {
  // Маршруты /avito/* регистрирует сам модуль avito
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'magsnab-avito-messenger',
    label: 'Avito: Сообщения',
    icon: IconMessages,
    url: '/avito/messenger',
    order: 25,
  }));

  WelcomeExtensions.navigationCards.register(() => ({
    key: 'magsnab-avito-calls',
    label: 'Avito: Звонки',
    icon: IconPhoneCall,
    url: '/avito/calls',
    order: 26,
  }));
}
